import { render, staticRenderFns } from "./Ric.vue?vue&type=template&id=c0a3e672"
import script from "./Ric.vue?vue&type=script&lang=js"
export * from "./Ric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports